import { useEffect, useState, useContext } from 'react';
import { FeedbackContext } from "../Context/FeedbackContext";
import { useQuery } from 'react-query';
import { Spinner } from 'react-bootstrap';
import { Loading } from "../../Components/Loading/Loading";
import { ErrorConnection } from "../../Components/Error/Error";
import Table from "../../Components/Table/tables";
import * as Utilities from '../../Components/Utils/Utils';
import Modal from 'react-bootstrap/Modal';



export default function TransposedTableFromServer({ idContent, setAuxData, apiService, args, conditions, header, pgSize, pgIndex, hideFilter, hideDownloadButton, hidePagination, fileNameDownload = "file.csv", transposedSettings, trheadStyle = [], frecuency, afluenciaMensualPeatonal = false }) {
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    const [refresh, setRefresh] = useState(true);
    const [tableData, setTableData] = useState();

    const [verModal, setVerModal] = useState(false);
    const [verModalDiferentYears, setVerModalDiferentYears] = useState(false);
    const [anioComparativoUsado, setAnioComparativoUsado] = useState(0);


    const prepareDataRows = async (data) => {
        let table = [];
        if (data) {
            //Adds all column "headers" (first row)
            for (let i = 0; i < data[0].row.length; i++) {
                await header.push(
                    {
                        Header: data[0].row[i],
                        accessor: data[0].row[i] + "-" + data[1].row[i],
                        headerClassName: 'text-gray-800 mb-1 bolder ',
                        className: 'min-w-100px column-right'
                    }
                );
            }
            //Adds data columns, taking into consideration data types 
            data.forEach((line, index) => {
                if (index == 0) return //first row already added lines above

                //header classes
                if (transposedSettings.hightlighted[index - 1]) {
                    transposedSettings.rowsClasses.push("bg-table-row")
                }
                else {
                    transposedSettings.rowsClasses.push("")
                };

                let temp = {};
                for (let i = 0; i < line.row?.length; i++) {
                    temp = {
                        ...temp,
                        [data[0].row[i] + "-" + data[1].row[i]]: transposedSettings.type[index - 1] == 'percentage' ? Utilities.setClassDiferenceTable(Utilities.comillasFix(line.row[i], true)) : transposedSettings.type[index - 1] == 'float' ? Utilities.comillasFix(line.row[i], true) : line.row[i]
                    }
                }
                table.push(temp);
            })
        }
        return table;
    }

    let { data: apiResponse, isLoading, isError, error, isFetching } = useQuery([idContent, args],
        async () => await apiService(args),
        {
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            enabled: Boolean(refresh) || conditions
        }
    );

    useEffect(async () => {
        if (apiResponse?.data) {
            if (!apiResponse.success)
                setFeedbackContext({ ...feedbackContext, showError: true, idError: apiResponse.errorId });
            else {
                if (apiResponse.data.auxData) {
                    if(afluenciaMensualPeatonal) {
                        if (`${args.anio2 - 1}-${args.anio2}` != apiResponse.data.auxData.anioComparativo ||
                        `${args.anio1 - 1}-${args.anio1}` != apiResponse.data.auxData.anioReporte) {
                            setAnioComparativoUsado(apiResponse.data.auxData.anioComparativo);
                            setVerModalDiferentYears(true);
                        }
                    } else {
                        if (args.anio2 != apiResponse.data.auxData.anioComparativo ||
                            args.anio1 != apiResponse.data.auxData.anioReporte) {
                            setAnioComparativoUsado(apiResponse.data.auxData.anioComparativo);
                            setVerModalDiferentYears(true);
                        }
                    }

                    if (frecuency == "Diaria") {
                        transposedSettings.firstColumn[0] = apiResponse.data.auxData.anioComparativo;
                        transposedSettings.firstColumn[2] = apiResponse.data.auxData.anioReporte;
                    } else if (frecuency == "Mensual") {
                        transposedSettings.firstColumn[0] = apiResponse.data.auxData.anioComparativo;
                        transposedSettings.firstColumn[1] = apiResponse.data.auxData.anioReporte;
                        transposedSettings.firstColumn[2] = "Presupuesto " + apiResponse.data.auxData.anioReporte;
                        transposedSettings.firstColumn[3] = "% " + apiResponse.data.auxData.anioReporte + " vs. " + apiResponse.data.auxData.anioComparativo;
                        transposedSettings.firstColumn[4] = "% " + apiResponse.data.auxData.anioReporte + " mes anterior";
                        transposedSettings.firstColumn[5] = apiResponse.data.auxData.anioReporte + " vs. Presupuesto";
                    }

                    if (setAuxData) setAuxData(apiResponse.data.auxData);
                }
                let dataTableFinal = await prepareDataRows(apiResponse.data.table);
                setTableData(dataTableFinal);
                setRefresh(false)
            }
        }
        else {
            setVerModal(true);
        }
    }, [apiResponse]);



    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error} />)
console.log('transposedSettings', transposedSettings)
    return (
        <>
            {
                isFetching &&
                <Spinner animation="grow" variant="secondary" />
            }
            {
                tableData && header.length > 2 ? (
                    <Table
                        idContent={idContent}
                        columns={header}
                        data={tableData}
                        pgSize={pgSize}
                        pgIndex={pgIndex}
                        hideFilter={hideFilter}
                        hideDownloadButton={hideDownloadButton}
                        hidePagination={hidePagination}
                        fileNameDownload={fileNameDownload}
                        transposedSettings={transposedSettings}
                        trheadStyle={trheadStyle}
                    />
                ) :
                    <>
                        <Modal

                            show={verModal}
                            onHide={() => setVerModal(false)}
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                        >
                            <Modal.Header>
                                <Modal.Title id="example-modal-sizes-title-sm" style={{ margin: 'auto' }}>
                                    {Utilities.monthFullNames[args.mes - 1]} - {args.anio1} vs {args.anio2}  - Quincena: {args.numero}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="alert alert-danger d-flex align-items-center p-5">

                                    <span className="svg-icon svg-icon-2hx svg-icon-danger me-4">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path opacity="0.3" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z" fill="black"></path>
                                            <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="black"></path>
                                        </svg>
                                    </span>

                                    <div className="d-flex flex-column">
                                        <h4 className="mb-1 text-danger">Advertencia</h4>
                                        <span>El mes seleccionado no tiene data registrada.</span>
                                    </div>
                                </div>

                            </Modal.Body>
                            <Modal.Footer style={{ margin: 'auto' }}>
                                <button type="button" className="btn btn-primary" onClick={() => setVerModal(false)}>
                                    Cerrar
                                </button>
                            </Modal.Footer>
                        </Modal>
                    </>
            }
            {
                verModalDiferentYears &&
                <>
                    <Modal

                        show={verModalDiferentYears}
                        onHide={() => setVerModalDiferentYears(false)}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        <Modal.Header>
                            <Modal.Title id="example-modal-sizes-title-sm" style={{ margin: 'auto' }}>
                                {Utilities.monthFullNames[args.mes - 1]} - {args.anio1} vs {args.anio2}  - Quincena: {args.numero}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="alert alert-danger d-flex align-items-center p-5">

                                <span className="svg-icon svg-icon-2hx svg-icon-danger me-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path opacity="0.3" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z" fill="black"></path>
                                        <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="black"></path>
                                    </svg>
                                </span>

                                <div className="d-flex flex-column">
                                    <h4 className="mb-1 text-danger">Advertencia</h4>
                                    <span>El año {args.anio2} no tiene datos registrados.
                                    </span>
                                    <span>Se encontro datos en el año {anioComparativoUsado}</span>
                                </div>
                            </div>

                        </Modal.Body>
                        <Modal.Footer style={{ margin: 'auto' }}>
                            <button type="button" className="btn btn-primary" onClick={() => setVerModalDiferentYears(false)}>
                                Cerrar
                            </button>
                        </Modal.Footer>
                    </Modal>
                </>
            }
        </>
    )
}